import { useEffect, useState } from 'react';
import { useApiFacade } from './use-api-facade';
import { CategoriesResponse } from '../interfaces/category.interface';

type UseGetCategories = [
	CategoriesResponse | undefined,
	Error | undefined,
	boolean,
];

export interface UseGetProductsQuery {
	limit?: number;
	offset?: number;
	name?: string;
	language?: string;
	ids?: string[];
	parentIds?: string[];
	coordinates?: number[];
	range?: number;
	countryCode?: string;
}

export const useGetCategories = (
	params: UseGetProductsQuery,
	role = 'customer',
	refresh?: number,
): UseGetCategories => {
	const facade = useApiFacade();
	const [data, setData] = useState<CategoriesResponse>();
	const [error, setError] = useState<Error>();
	const [isLoading, setIsLoading] = useState(false);
	const language = localStorage.getItem('lang') || 'en';

	const finishLoading = () => {
		setTimeout(() => {
			setIsLoading(false);
		}, 200);
	};

	useEffect(() => {
		const {
			parentIds = [],
			ids = [],
			limit = 100,
			offset = 0,
			coordinates,
			range,
			countryCode,
		} = params;
		if (coordinates && coordinates.length === 0) {
			setData({ count: 0, items: [] });
			return;
		}
		if (!countryCode && role !== 'admin') {
			setData({ count: 0, items: [] });
			return;
		}
		setIsLoading(true);
		let query: UseGetProductsQuery = {
			limit,
			offset,
			parentIds,
			ids,
			language,
		};
		if (coordinates?.length) {
			query = {
				...query,
				coordinates,
				range: range || 500,
			};
		}
		if (countryCode) {
			query = {
				...query,
				countryCode,
			};
		}
		facade.client
			.get(`/v1/${role}/categories`, {
				params: query,
			})
			.then((response) => {
				setData(response.data);
				finishLoading();
			})
			.catch((err) => {
				setError(err);
				finishLoading();
			});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [JSON.stringify(params), role, facade, refresh]);

	return [data, error, isLoading];
};
